<div class="absolute w-50 h-50">
  <span class="loader inline-block w-full h-full"></span>
</div>
